import { useEffect, useState } from 'react';

import p1 from "../photos/1.jpeg";
import p2 from "../photos/2.jpg";
import p3 from "../photos/3.jpeg";
import p4 from "../photos/4.jpg";
import p5 from "../photos/5.jpg";
import p6 from "../photos/6.jpg";
import p7 from "../photos/7.jpeg";
import p8 from "../photos/8.jpeg";
import p9 from "../photos/9.jpg";
import p10 from "../photos/10.jpeg";
import p11 from "../photos/11.jpg";
import p12 from "../photos/12.jpg";
import p13 from "../photos/13.jpg";
import p14 from "../photos/14.jpg";
import p15 from "../photos/15.jpg";
import p16 from "../photos/16.jpg";
import p17 from "../photos/17.jpeg";
import p18 from "../photos/18.jpg";
import p19 from "../photos/19.jpeg";
import p20 from "../photos/20.jpeg";
import p21 from "../photos/21.jpg";
import p22 from "../photos/22.jpg";
import p23 from "../photos/23.jpg";
import p24 from "../photos/24.jpg";
import p25 from "../photos/25.jpg";
import p26 from "../photos/26.jpg";
import p27 from "../photos/27.jpg";
import p28 from "../photos/28.jpg";
import p29 from "../photos/29.jpg";
import p30 from "../photos/30.jpg";
import p31 from "../photos/31.jpg";
import p32 from "../photos/32.jpg";
import p33 from "../photos/33.jpg";
import p34 from "../photos/34.jpg";
import p35 from "../photos/35.jpg";


import { useScrollLock } from '../tools/useScrollLock';
import ArtworkCard from '../components/ArtworkCard.js';


const GalleryPage = ({ language }) => {
    const importAll = (r) => r.keys().map(r);
    const images = importAll(require.context('../photos', false, /\.(png|jpe?g|gif)$/));
    let artworkTitles = {
        1: [p1, ["Προσμονή", "Anticipation"], "80x100", ["Λάδι σε Καμβά", "Oil on Canvas"], false, 26, "nature"],
        2: [p2, ["Ερωτευμένες Ορχιδέες", "Loving Orchids"], "60x80", ["Λάδι σε Καμβά", "Oil on Canvas"], false, 20, "nature"],
        3: [p3, ["Άγριες Ορχιδέες", "Wild Orchids"], "", ["Λάδι σε Καμβά", "Oil on Canvas"], false, 3, "nature"],
        4: [p4, ["Πορταίτο Γιάννης", "Portrait Giannis"], "50x60", ["Λάδι σε Καμβά", "Oil on Canvas"], false, 6, "portrait"],
        5: [p5, ["Πορτραίτο", "Portrait"], "80x100", ["Λάδι σε Καμβά", "Oil on Canvas"], false, 17, "portrait"],
        6: [p6, ["Πορταίτο Ελια", "Portrait Elia"], "50x60", ["Λάδι σε Καμβά", "Oil on Canvas"], false, 1, "portrait"],
        7: [p7, ["Φίλες", "Friends"], "100x90", ["Λάδι σε Καμβά", "Oil on Canvas"], true, 5, "portrait"],
        8: [p8, ["Πορτραίτο", "Portrait"], "50x60", ["Λάδι σε Καμβά", "Oil on Canvas"], false, 99, "portrait"],
        9: [p9, ["Πειρασμός", "Temptation"], "60x70", ["Λάδι σε Καμβά", "Oil on Canvas"], false, 17, "nature"],
        10: [p10, ["Περιγιάλι", "Perigiali"], "80x60", ["Λάδι σε Καμβά", "Oil on Canvas"], true, 12, "nature"],
        11: [p11, ["Η Συνάντηση", "The Meeting"], "70x50", ["Λάδι σε Καμβά", "Oil on Canvas"], false, 24, "nature"],
        12: [p12, ["Φραγκοσυκιές", "Prickly Pears"], "80x100", ["Λάδι σε Καμβά", "Oil on Canvas"], false, 25, "nature"],
        13: [p13, ["Αναζήτηση", "Search"], "90x70", ["Λάδι σε Καμβά", "Oil on Canvas"], true, 9, "portrait"],
        14: [p14, ["Αδάμ", "Adam"], "60x80", ["Λάδι σε Καμβά", "Oil on Canvas"], false, 5, "portrait"],
        15: [p15, ["Φουσκοθαλασσιά", "Rough Sea"], "100x80", ["Λάδι σε Καμβά", "Oil on Canvas"], false, 4, "nature"],
        16: [p16, ["Παπαγάλος", "Parrot"], "50x70", ["Λάδι σε Καμβά", "Oil on Canvas"], false, 14, "nature"],
        17: [p17, ["Πορτραίτο", "Portrait"], "70x60", ["Λάδι σε Καμβά", "Oil on Canvas"], true, 3, "portrait"],
        18: [p18, ["Κούμαρα", "Strawberry Tree Fruit"], "40x30", ["Λάδι σε Καμβά", "Oil on Canvas"], false, 28, "nature"],
        19: [p19, ["Γέφυρα Ριάλτο", "Rialto Bridge"], "50x70", ["Λάδι σε Καμβά", "Oil on Canvas"], false, 11, "nature"],
        20: [p20, ["Φλαμίγκο", "Flamingo"], "50x70", ["Λάδι σε Καμβά", "Oil on Canvas"], false, 2, "nature"],
        21: [p21, ["Μπούρτζι", "Bourtzi"], "60x80", ["Λάδι σε Καμβά", "Oil on Canvas"], false, 10, "nature"],
        22: [p22, ["Πανέρι με φραγκόσυκα", "Basket with Prickly Pears"], "60x50", ["Λάδι σε Καμβά", "Oil on Canvas"], false, 27, "nature"],
        23: [p23, ["Πορτραίτο Φούλη", "Portrait Fouli"], "50x60", ["Λάδι σε Καμβά", "Oil on Canvas"], false, 2, "portrait"],
        24: [p24, ["Βάρκα", "Boat"], "60x50", ["Λάδι σε Καμβά", "Oil on Canvas"], false, 5, "nature"],
        25: [p25, ["Γυαλιστερή με Ορχιδέα", "Glossy with Orchid"], "100x80", ["Λάδι σε Καμβά", "Oil on Canvas"], true, 1, "nature"],
        26: [p26, ["Γυμνό", "Nude"], "80x100", ["Λάδι σε Καμβά", "Oil on Canvas"], false, 7, "portrait"],
        27: [p27, ["Δαυίδ του Μιχαήλ Άγγελου", "Michelangelo’s David"], "", ["Μολύβι σε Χαρτί", "Pencil on Paper"], false, 10, "portrait"],
        28: [p28, ["Μπουρου", "Bourou"], "80x60", ["Λάδι σε Καμβά", "Oil on Canvas"], false, 18, "nature"],
        29: [p29, ["Ανθισμένη Αλόη", "Blooming Aloe"], "80x100", ["Λάδι σε Καμβά", "Oil on Canvas"], false, 16, "nature"],
        30: [p30, ["Στρείδι", "Oyster"], "100x80", ["Λάδι σε Καμβά", "Oil on Canvas"], false, 19, "nature"],
        31: [p31, ["Κορίτσι στην Παραλία", "Girl on the Beach"], "", ["Λάδι σε Καμβά", "Oil on Canvas"], false, 7, "nature"],
        32: [p32, ["Καταιγίδα", "Storm"], "80x60", ["Λάδι σε Καμβά", "Oil on Canvas"], false, 6, "nature"],
        33: [p33, ["Αλκυόνη", "Kingfisher"], "50x70", ["Λάδι σε Καμβά", "Oil on Canvas"], false, 15, "nature"],
        34: [p34, ["Κρινάκια", "Lilies"], "50x70", ["Λάδι σε Καμβά", "Oil on Canvas"], false, 13, "nature"],
        35: [p35, ["Γυμνό", "Nude"], "70x100", ["Λάδι σε Καμβά", "Oil on Canvas"], false, 8, "portrait"],
    };


    const [selectedImg, setSelectedImg] = useState(null);
    const [isVisible, setIsVisible] = useState(false);

    useScrollLock(isVisible);

    const openModal = (src, title, dimensions, media) => {
        setSelectedImg({
            src: src,
            title: title,
            dimensions: dimensions,
            media: media
        });
        setIsVisible(true);
    }
    const closeModal = () => {
        setIsVisible(false);
        setTimeout(() => setSelectedImg(null), 200);
    }

    useEffect(() => {
        if (selectedImg) {
            document.body.classList.add('no-scroll');
        } else {
            document.body.classList.remove('no-scroll');
        }

        return () => {
            document.body.classList.remove('no-scroll');
        };
    }, [selectedImg]);

    const sortedEntries = Object.entries(artworkTitles).sort(([, valueA], [, valueB]) => valueA[5] - valueB[5]);
    console.log(sortedEntries);
    return (
        <>
            <div className='gallery-content'>
                <div className="title-div"> <p className='first'> {language === "en" ? "Nature" : "Φύση"}</p></div>
               
                <div className="artwork-grid">
                    {
                        sortedEntries.filter(a=>a[1][6] == "nature").map(a => a[1]).map((item, i) => {
                            return (
                                language === "en" ? (<ArtworkCard
                                    key={i}
                                    src={item[0]}
                                    openModal={openModal}
                                    title={item[1][1]}
                                    media={item[3][1]}
                                    dimensions={item[2]}
                                    isLargeSize={item[4]}
                                />) : (
                                    <ArtworkCard
                                        key={i}
                                        src={item[0]}
                                        openModal={openModal}
                                        title={item[1][0]}
                                        media={item[3][0]}
                                        dimensions={item[2]}
                                        isLargeSize={item[4]}
                                    />
                                )



                            );
                        })
                    }
                </div>

                <div className="title-div"> <p> {language === "en" ? "Portraits" : "Πορτραίτα"}</p></div>
                <div className="artwork-grid">
                    {
                        sortedEntries.filter(a=>a[1][6] == "portrait").map(a => a[1]).map((item, i) => {
                            return (
                                language === "en" ? (<ArtworkCard
                                    key={i}
                                    src={item[0]}
                                    openModal={openModal}
                                    title={item[1][1]}
                                    media={item[3][1]}
                                    dimensions={item[2]}
                                    isLargeSize={item[4]}
                                />) : (
                                    <ArtworkCard
                                        key={i}
                                        src={item[0]}
                                        openModal={openModal}
                                        title={item[1][0]}
                                        media={item[3][0]}
                                        dimensions={item[2]}
                                        isLargeSize={item[4]}
                                    />
                                )



                            );
                        })
                    }
                </div>

                {selectedImg && (
                    <div className={`artwork-image-modal ${isVisible ? 'active' : 'closing'}`} onClick={closeModal}>
                        <div className='modal-wrapper'>
                            <div className='modal-info'>
                                <div className='center col'>
                                    <p className='normal'>{selectedImg.title}</p>
                                    {selectedImg.media && <p className='small grey'>{selectedImg.media}</p>}
                                    {selectedImg.dimensions && <p className='smaller grey'>{selectedImg.dimensions}</p>}
                                </div>
                            </div>
                            <img className="modal-image" src={selectedImg.src} alt="Zoomed" />
                        </div>
                    </div>
                )}
            </div >
        </>
    )
}

export default GalleryPage;